import { useSelector } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import type { State } from 'Flux/Slice/index.js'
import type { IPipelineState } from '../../../../Model/Order/IPipelineState.js'

export const useGetPipelineStateSelector: () => IPipelineState | null = () => {
  return useSelector(selectPipelineState)
}

const selectPipelineState = (state: typeof State) => state[orderSlice.name].pipelineState
